<template>
  <div>
    <md-toolbar
      :class="{ 'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute }"
      md-elevation="16"
      style="height: 50px"
      align="Center"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ $route.name }}</h3>
        </div>

        <div class="md-toolbar-section-end">
          <md-list>
            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#">
              <p class="hidden-sm">&nbsp;</p>
              |
            </md-list-item>

            <a v-if="$route.name == 'Screening Evaluation'" ref="#">
              <drop-down direction="down">
                <md-button slot="title" class="md-sm" style="margin-top: 5px">
                  <i class="material-icons">folder_special</i>
                  <p class="hidden-sm">&nbsp;on-hold</p>
                </md-button>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li><a href="#">Screening on-hold 1</a></li>
                  <li><a href="#">Screening on-hold 2</a></li>
                  <li><a href="#">Screening on-hold 3</a></li>
                  <li><a href="#">Screening on-hold 4</a></li>
                  <li><a href="#">Screening on-hold 5</a></li>
                </ul>
              </drop-down>
            </a>

            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#" @click="saveAndRedirect">
              <i class="material-icons">save</i>
              <p class="hidden-sm">&nbsp;{{ screeningStatus == "hold" ? "Save" : "Hold" }}</p>
            </md-list-item>

            <md-list-item
              v-if="$route.name == 'Screening Evaluation' && screeningStatus == 'hold'"
              href="#"
              @click="activateScreening"
            >
              <i class="material-icons">done</i>
              <p class="hidden-sm">&nbsp;Release</p>
            </md-list-item>

            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#">
              <p class="hidden-sm">&nbsp;</p>
              |
            </md-list-item>

            <md-list-item href="#" @click="showSwal('logout-confirmation')">
              <i class="material-icons">exit_to_app</i>
              <p class="hidden-sm">&nbsp;Logout</p>
            </md-list-item>
          </md-list>

          <md-button
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <!--</div>-->
        </div>
      </div>
    </md-toolbar>
  </div>
</template>

<script>
import Swal from "sweetalert2"

export default {
  data() {
    return {
      onhold: false,
      selectedEmployee: "",
      employees: []
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    showSwal(type) {
      if (type === "logout-confirmation") {
        Swal.fire({
          title: "LOGOUT",
          text: `Are you sure you want to logout?`,
          //type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("auth/logout").then(() => {
              sessionStorage.clear()
              this.$router.push({ path: "/" })
            })
          }
        })
      } else if (type === "save-message") {
        Swal.fire({
          title: `Evaluation Saved!`,
          text: "...and placed in your on-hold queue.",
          buttonsStyling: false,
          confirmButtonClass: "md-button md-success",
          type: "success"
        }).then(() => {
          this.onhold = true
        })
      }
    }
  }
}
</script>
